module.exports = __webpack_public_path__ + "img/17872_L.65d2b8b2.png";